import controller from './workflow.controller';
import template from './workflow.html';

export default {
	path:         '/workflow/:affectKid',
	template,
	controller,
	controllerAs: '$ctrl',
	title:        'list.workflow',
};
